import { has, exists, is_true } from "../utils";
import { dispatch_action } from "../redux/Dispatcher";
import { Action } from "../redux/Actions";

export function message_event_listener(event: MessageEvent){
    if(typeof(event.data)===typeof("")){
        // if the data element is not an object, bail.
        return;
    }
    let msg_type:string = event.data.msgType;

    if ( has(event.data, "msg_type")) {
        msg_type = event.data.msg_type;
    }

    if (!exists(msg_type)) {
        console.error("missing 'msg_type' value");
        return;
    }

    msg_type = msg_type.toUpperCase();
   
    if (msg_type === "WORKORDER_DATA") {  // this message is sent when a work order has been edited
        console.info("ui_event update workorder");
        var workorder_data = event.data.workorder;
        dispatch_action(Action.update_workorders([workorder_data]));
        return;
    }

    if (msg_type === "WORKORDERS") {
        let query:any = event.data.query;
        // when the parent app sets wait_assets, hold this query until the assets query
        // returns, then send it scoped to the ids of the assets that came back.
        const wait_assets: boolean = is_true(event.data.wait_assets);

        if (query === undefined) {
            console.error("Workorders query received, but the query was missing");
            return;
        }

        dispatch_action(Action.set_workorder_query(query, wait_assets));
        return;
    }

    if (msg_type == "ASSETS") {
        const query:any = event.data.query;

        if (query === undefined) {
            console.error("Assets query received, but the query was missing");
            return;
        }

        dispatch_action(Action.set_assets_query(query));
        return;
    }

    console.debug("unhandled msg_type " + msg_type);
}